import React, { useState, useEffect } from 'react';
import {
  RideModal,
  RideModalContent,
  RideButton,
  RideTextField
} from '@rimac-seguros/ride-system-components';
import DynamicIcon from '@/components/atoms/DynamicIcon/index';
import { Regex } from '@/utils/regex';
import useBreakpoint from '@/hooks/useBreakpoint';

const Modal = ({
  isOpen,
  icon,
  title,
  subtitle,
  button,
  closeModal,
  viewForm,
  handleSendMail,
  loadingModal
}) => {

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const isTablet = useBreakpoint('tablet');

  useEffect(() => {
    setEmail('');
    setEmailError('');
  }, []);

  const handleEmailInput = (e) => {
    const { value } = e.target;
    setEmail(value);
    setEmailError(!Regex.email.test(value));
  }

  return (
    <RideModal
      isOpen={isOpen}
      onCloseButtonClick={closeModal}
      size="small"
      variant="new"
    >
      <RideModalContent>
        <div className="pb-ride-gl-spacing-6xlarge flex flex-col gap-ride-gl-spacing-2xlarge md:px-ride-gl-spacing-5xlarge">
          {icon &&
            <div className="flex w-full justify-center">
              <DynamicIcon
                icon={icon}
                size='large'
              />
            </div>
          }
          <h4 className="ride-sys-text-title-3xlarge-default text-center">{title}</h4>
          <p className="ride-sys-text-paragraph-large-regular text-center">{subtitle}</p>
          {viewForm &&
            <div className="flex flex-col gap-ride-gl-spacing-2xlarge">
                <RideTextField
                  label="Correo electrónico"
                  size="large"
                  value={email}
                  required
                  messageError="*El correo electrónico es inválido"
                  onInput={handleEmailInput}
                  error={emailError}
                  errorMessage="*El correo electrónico es inválido"
                />
                <div className="flex w-full justify-center">
                  <RideButton
                    text="Enviar"
                    size="large"
                    onClick={() => handleSendMail(email)}
                    loading={loadingModal}
                    fullWidth={!isTablet}
                  />
                </div>
            </div>
          }
          {button &&
            <div className="flex w-full justify-center">
              <RideButton
                text={button}
                size="large"
                onClick={closeModal}
              />
            </div>
          }
        </div>
      </RideModalContent>
    </RideModal>
  )
};

export default Modal;